import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/email_templates_library'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  privateTemplates: {
    hasMore: false,
    items: []
  },
  publicTemplates: {
    hasMore: false,
    items: []
  },
  templateFormData: {
    id: null,
    name: null,
    shared: false,
    released: false,
    json: null,
    html: null,
    isDirty: false
  }
})

export default handleActions({
  [Actions.setTemplateFormData]: (state, { payload: { key, value } }) => (
    state.setIn(['templateFormData', key], value).setIn(['templateFormData', 'isDirty'], true)
  ),
  [Actions.loadSelectedTemplate]: (state, { payload }) => (
    state.set('templateFormData', payload)
  ),
  [Actions.closeEditorDialog]: state => state.set('templateFormData', initialState.get('templateFormData')),
  [Actions.saveTemplateSuccess]: (state, { payload }) => {
    if (!payload) {
      return state
    }

    const { id, shared } = payload
    const privateTemplates = state.getIn(['privateTemplates', 'items'])
    const publicTemplates = state.getIn(['publicTemplates', 'items'])
    const newTemplate = fromJS(payload)

    const upsert = list => {
      const index = list.findIndex(template => template.get('id') === id)

      return index !== -1
        ? list.set(index, newTemplate)
        : list.unshift(newTemplate)
    }

    let nextState = state.setIn(['privateTemplates', 'items'], upsert(privateTemplates))

    if (shared) {
      nextState = nextState.setIn(['publicTemplates', 'items'], upsert(publicTemplates))
    }

    return nextState
  },
  [Actions.fetchTemplatesSuccess]: (state, { payload: { shared, result: { templates, hasMore } } }) => {
    const key = shared ? 'publicTemplates' : 'privateTemplates'

    return state
      .updateIn([key, 'items'], templatesList => templatesList.push(...fromJS(templates)))
      .setIn([key, 'hasMore'], hasMore)
  },
  [Actions.deleteTemplateSuccess]: (state, { payload: { id, shared } }) => {
    if (shared) {
      return state
        .setIn(['publicTemplates', 'items'], state.getIn(['publicTemplates', 'items'])
          .filter(template => template.get('id') !== id))
        .setIn(['privateTemplates', 'items'], state.getIn(['privateTemplates', 'items'])
          .filter(template => template.get('id') !== id))
    }

    return state.setIn(['privateTemplates', 'items'], state.getIn(['privateTemplates', 'items'])
      .filter(template => template.get('id') !== id))
  },
  [Actions.resetTemplatesModule]: () => initialState,
  [AppActions.resetState]: () => initialState
}, initialState)
